import {Control} from '../Control.js';
import Library from '../Library.js';

export class TimeSlider extends Control {
    slider = undefined;
    times = [];
    changeCallback = undefined;
    ind = 0;

    constructor( map, settings = {} ){
        settings['name'] = "time_slider";
        if( settings['target'] == undefined ) settings['target'] = "time_slider";

        if( settings['min'] == undefined ) settings['min'] = 0;
        if( settings['max'] == undefined ) settings['max'] = 12;
        if( settings['value'] == undefined ) settings['value'] = 6;
        let onchange = undefined;
        if( settings['onchange'] != undefined ){ onchange = settings['onchange']; delete settings['onchange']; };
        super( map, settings );
        if( onchange ) this.changeCallback = onchange;

        this.getState();

        let div = document.getElementById( this.target );
        if( div == undefined) return;

        this.slider = document.createElement('input');
        this.slider.type = 'range';
        this.slider.id = 'time_slider_range';
        this.slider.min = settings['min'];
        this.slider.max = settings['max'];
        this.slider.value = settings['value'];
        this.slider.addEventListener('change', this.change.bind(this) );
        this.slider.addEventListener('input', this.slide.bind(this) );
        div.appendChild(this.slider);

        this.setLabels();
    }

    getTime(val){
        return this.map.init_secs + val * 3600;
    }

    refresh(){
        console.info( 'refresh time slider');
        this.setLabels();
    }

    setLabels(){
        document.querySelectorAll('.time_slider_tick').forEach(el => el.remove());
        document.querySelectorAll('.time_slider_tick_min').forEach(el => el.remove());
        document.querySelectorAll('.time_slider_now').forEach(el => el.remove());
        document.querySelectorAll('.time_slider_val').forEach(el => el.remove());

        let div = document.getElementById( this.target );
        if( div == undefined) return 0;

        let vals = this.slider.max - this.slider.min;
        let skip = 3;
        let thumb = 10;
        let xlen = 100-thumb;
        let t = 0;
        for( let i = this.slider.min; i <= this.slider.max; i++ ){
            // Add ticks
            let el = document.createElement('label');
            if( i % skip == 0 )
                el.className = 'time_slider_tick';
            else
                el.className = 'time_slider_tick_min';
            el.textContent = '|';
            el.setAttribute('ind', i);
            el.style.left = (t / vals * xlen + thumb/2) + '%';
            el.addEventListener('click', (e) => { 
                    let ind = e.target.attributes.ind.value;
                    let elem = document.getElementById( "time_slider_range" );
                    elem.value = ind; 
                    this.change(ind) 
                    });
            div.append(el);
            // Add labels
            let time = this.getTime(i);
            let str = "";
            //let xoff2 = 0;
            if( i % skip == 0 ){
                if( i == 0 ){
                    str = Library.formatDate( "%H%M", time );
                    console.info( "time_slider_now", str);
                }
                else
                    str = Library.formatDate( "%HZ", time );
            }

            let el2 = document.createElement('label');
            if( i == 0 )
                el2.className = 'time_slider_now';
            else 
                el2.className = 'time_slider_val';
            el2.textContent = str;
            el2.setAttribute('ind', i);
            el2.style.left = (t / vals * xlen + thumb/2) + '%';
            el2.addEventListener('click', (e) => { 
                    let ind = e.target.attributes.ind.value; 
                    let elem = document.getElementById( "time_slider_range" );
                    elem.value = ind; 
                    this.change(ind) 
                    });
            div.append(el2);
            t++;
        }
    }

    increment(inc){
        let elem = document.getElementById( "time_slider_range" );
        let val = parseInt(elem.value);

        if( inc != 0 )
            val = val + inc;
        else
            val = 0;
        if( val < this.slider.min ) val = this.slider.min;
        if( val > this.slider.max ) val = this.slider.max;
        elem.value = val;
        this.change(val);
    }

    change( event, ui ){
        let value = event;
        console.info( 'change' , event, ui );
        if( event.target ){
value = parseInt( event.target.value );
console.info( 'xx');
        }
            
        this.ind = value;
        let secs = this.getTime( value );
        this.map.secs = secs;
        let date = Library.formatDate("ymd_hn", this.map.secs );
        let ctl;
        if( ctl = this.map.searchControl('date_label')) ctl.refresh();
        console.info('update time', value, date );
        for( let lay in this.map.layers ){
            console.info( lay, this.map.layers[lay].name, this.map.layers[lay].refresh['level']);
            if( this.map.layers[lay].dynamic['time'] ){
                console.info( 'time refresh', this.map.layers[lay].name )
                this.map.layers[lay].updateTime();
            }
        }
        this.changeCallback(value, date);
    }

    slide( event, ui ){
        console.info( "time slide");
        let value = event;
        if( event.target )
            value = parseInt( event.target.value );
        this.ind = value;
        let secs = this.getTime( value );
        this.map.secs = secs;
        let date = Library.formatDate("", this.map.secs );
        let ctl;
        if( ctl = this.map.searchControl('date_label')) ctl.setLabel("[" + value + "-" + date + "]");
    }
}